<script>
  import HomePageHero from "$lib/components/Hero/HomePageHero.svelte";
  import LandingPageHero from "$lib/components/Hero/LandingPageHero.svelte";
  import Hero from "$lib/components/Hero/Hero.svelte";

  export let data;

  export const COMPONENT_MAP = {
    "Home Page with Fixed Background": HomePageHero,
    "Landing Page with Background": HomePageHero, // to be deprecated
    "Landing Page with Featured Image": LandingPageHero,
    "Landing Page with Flex Background": LandingPageHero,
    "Text Only": Hero,
    "Text with Image": Hero
  };

  export const VARIANT_MAP = {
    "Home Page with Fixed Background": "fixed-background",
    "Landing Page with Background": "fixed-background", // to be deprecated
    "Landing Page with Featured Image": "featured",
    "Landing Page with Flex Background": "background"
  };

  let component = COMPONENT_MAP[data.fields.formFactor];
  let variant = VARIANT_MAP[data.fields.formFactor];
</script>

<svelte:component
  this={component}
  logo={data.fields.logo}
  eyebrow={data.fields.eyebrow
    ? {
        content: data.fields.eyebrow.fields.text,
        link: data.fields.eyebrow.fields.url
      }
    : {}}
  title={data.fields.title}
  showSocialBar={data.fields.showSocialBar}
  featuredImage={data.fields.featuredImage}
  cta={data.fields.callToAction?.fields}
  links={{ fields: { items: data.fields.links } }}
  bgColor={data.fields.backgroundColor}
  richTextContent={data.fields.richTextContent}
  toggleRichTextContent={data.fields.toggleRichTextContent}
  {variant}
/>
